/**
 * @ngdoc directive
 * @name adjust.apps.directive:customSelect
 * @scope
 * @restrict E
 *
 * @description
 * Custom select directive which allows user to
 * - Select values from list with search filter
 * - Define custom value which is not part of the list
 * - Select multiple values from list
 * - Add custom values to list on multiple select (tagging)
 *
 * @param {boolean} custom if custom value is supported
 * @param {Object} options list of options
 * @param {boolean} disabled disables the input
 * @param {string} placeholder input placeholder
 * @param {string} matchView angular interpolate expression for match
 * @param {string} listView angular interpolate expression for list items
 * @param {string|array} modelValue model binded value
 * @param {string} dropdownPosition dropdown position direction (up|down\auto)
 * @param {Function} onChange on change callback
 * @param {Function} onSelect on select callback
 * @param {Function} onDeselect on deselect callback
 * @param {Function} onSearch on search callback
 * @param {Number} onSearchMinChars minimum amount of characters required to fire onSearch
 * @param {boolean} hideSearch hide/show the search input
 * @param {boolean} stayOnSelect hide/show the dropdown on selection
 * @param {boolean} resetSearchTerm resets the search term on selection
 *
 */
function customSelect(customSelectParse) {
  'ngInject';
  return {
    restrict: 'E',
    scope: {},
    controller: 'CustomSelectController',
    controllerAs: '$select',
    compile: compileTemplate,
    bindToController: {
      custom: '@',
      options: '=?',
      disabled: '=',
      placeholder: '@',
      matchView: '@',
      listView: '@',
      repeat: '@',
      removeable: '@',
      dropdownPosition: '@?',
      modelValue: '=?ngModel',
      onChange: '&?',
      onSelect: '&?',
      onDeselect: '&?',
      onSearch: '&?',
      onSearchMinChars: '=?',
      hideSearch: '@?',
      stayOnSelect: '@?',
      resetSearchTerm: '@?',
      taggingTokens: '@?',
      inputTestid: '@?',
    },
    require: ['customSelect', '?^ngModel'],
    template: getTemplate,
  };

  function compileTemplate(tElem, tAttrs) {
    var isMultiple = angular.isDefined(tAttrs.multiple) || angular.isDefined(tAttrs.tagging);

    var dropdown = tElem[0].querySelector('[compile-options]');
    var match = tElem[0].querySelector('[compile-match]');

    var paramRep = customSelectParse.parse(tAttrs.repeat);

    // Defaults for match and list view
    var matchView = tAttrs.matchView || (isMultiple ? '{{$item}}' : '{{$select.selected.value}}');
    var listView =
      tAttrs.listView || (isMultiple ? '{{' + paramRep.itemName + '}}' : '{{' + paramRep.itemName + '.label}}');

    var templateOptions =
      '<li ng-repeat=" ' +
      paramRep.repeatExpression() +
      '| filter:$select.search">' +
      '<a href ' +
      'data-custom-select-item ' +
      'tabindex="-1" ' +
      'ng-click="$select.selectItem(' +
      paramRep.itemName +
      ')" ' +
      'ng-class="{active: $index === $select.focus}">' +
      listView +
      '</a>' +
      '</li>'.concat();

    var templateMultiOptions =
      '<li ng-repeat=" ' +
      paramRep.repeatExpression() +
      '| filter:$select.search | filter:$select.isNotSelected">' +
      '<a href ' +
      'data-custom-select-item ' +
      'tabindex="-1" ' +
      'ng-click="$select.selectItem(' +
      paramRep.itemName +
      ')" ' +
      'ng-class="{active: $index === $select.focus}">' +
      listView +
      '</a>' +
      '</li>'.concat();

    angular.element(match).replaceWith(matchView);
    angular.element(dropdown).replaceWith(isMultiple ? templateMultiOptions : templateOptions);

    return function(scope, element, attrs, ctrls) {
      var [$select, ngModel] = ctrls;

      if (ngModel) {
        $select.setNgModel = ngModel.$setViewValue;
        $select.setModelDirty = ngModel.$setDirty;
      }
    };
  }

  function getTemplate(tElem, tAttrs) {
    var multiple = require('./custom-select-multiple.html');
    var single = require('./custom-select-single.html');
    var templateType = angular.isDefined(tAttrs.multiple) || angular.isDefined(tAttrs.tagging) ? multiple : single;

    return templateType;
  }
}

export { customSelect };
